'use client'

import { createContext, useContext, useState } from 'react'

import { useDeviceScreen } from '@canyon/ui/hooks'
import { usePathname } from 'next/navigation'

export const SidebarContext = createContext<{
  isCompactMode: boolean
  isCompacted: boolean
  isSidebarOpen: boolean
  setIsSidebarOpen: (isSidebarOpen: boolean) => void
}>({
  isCompactMode: false,
  isCompacted: false,
  isSidebarOpen: true,
  setIsSidebarOpen: () => {},
})

export const SidebarProvider = ({ children }: { children: React.ReactNode }) => {
  const pathname = usePathname()
  const isResumeBuilderPage = pathname?.includes('/resumes/')
  const [isSidebarOpen, setIsSidebarOpen] = useState(!isResumeBuilderPage)
  const { isMobile } = useDeviceScreen()
  const isCompacted = !isMobile && !isSidebarOpen
  const isCompactMode = !isMobile && !isSidebarOpen

  return (
    <SidebarContext.Provider
      value={{ isCompactMode, isCompacted, isSidebarOpen, setIsSidebarOpen }}
    >
      {children}
    </SidebarContext.Provider>
  )
}

export const useSidebar = () => {
  const context = useContext(SidebarContext)

  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider')
  }

  return context
}
